import { SelectItem } from 'primeng/api';
import {
    CONSULTATION_TYPES,
    DIET_FOOD_DESC,
    DIET_FOOD_DESC_PLACEHOLDER,
    DIET_HEALTH_GOAL,
    GOOGLE_RECAPTCHA_SITE_KEY,
    MEDICAL_CONDITION_DESCRIPTION
} from '../constant/constant';
import { Payment_Data } from './basket';
// import { Packages, Packages_Form, Package_Status } from "./package";
import { PackageStatusModel } from './package';
import { ApiResult } from './PromiseResult';
import { InvoicePrint } from './transactions';
import { Component_Leave, REG_EXP, TabView_Data } from './util.models';
import { SlotData } from './schedule';
import { Patient_Registration_Data, PhoneNumberExists, patientEdit_Data } from './User';
import { CONSULTATION_FORMS_TABS } from '../components/portal-home/consultation-flow/consultation-flow.component';
import { CountrySelectedValue } from './doctorregistration';

export class DiscountCode {
    patient_guid: string = '';
    discount_code: string = '';
}
export class CouponCode {
    index: number = null;
    discount_code: string = '';
    discount_id: string = '';
    discount_percent: string = '';
    egd_referral_master_type: {
        referral_type: string;
    } = {
            referral_type: ''
        };
}

export class CouponCodeData {
    show_all: boolean = false;
    current_list_count: number = 0;
    discount_code_api: DiscountCode = new DiscountCode();

    constructor(current_list_count_number: number) {
        this.current_list_count = current_list_count_number;
    }
}

export class PackageConsultDoctorApiData {
    patient_guid: string = null;
    consultation_type_id: number = null;
}

export class PackageConsultDoctorOtherData {
    consultationDisabled: boolean = false;
    specialtyHide: boolean = false;
    specialty_name: string = '';
    priorityDisabled: boolean = false;
    priority_type_id: number = null;
    packagesDiabled: boolean = false;
}

export class PackageConsultDoctor {
    apiData: PackageConsultDoctorApiData = new PackageConsultDoctorApiData();
    otherData: PackageConsultDoctorOtherData = new PackageConsultDoctorOtherData();
}
export class DietConditonPropertiesType {
    quantity_type: null | 'hours' | 'litres' = null;
    quantity: number = null;
    quantity_string: string = null; //just for printing N/A
    quantity_label: string = null;
    date: string = null;
    time: string = null;
    timeDate: Date = null;
    isTime: boolean = true;
    quantity_description: string = '';
}

export class DietConditionType {
    data_type: string = '';
    description: string = null;
    properties: DietConditonPropertiesType[] = [
        new DietConditonPropertiesType()
    ];

    constructor(
        diet_data_type:
            | 'breakfast'
            | 'lunch'
            | 'snack_1'
            | 'snack_2'
            | 'sleep'
            | 'water'
            | 'dinner'
    ) {
        this.data_type = diet_data_type;
        if (diet_data_type == 'sleep') {
            this.properties[0].isTime = false;
            this.properties[0].quantity_type = 'hours';
            this.properties[0].quantity_description = null;
        } else if (diet_data_type == 'water') {
            this.properties[0].isTime = false;
            this.properties[0].quantity_type = 'litres';
            this.properties[0].quantity_description = null;
        }
    }
}

export class DietFoodData {
    breakfast: DietConditionType = new DietConditionType('breakfast');
    lunch: DietConditionType = new DietConditionType('lunch');
    dinner: DietConditionType = new DietConditionType('dinner');
    snack_1: DietConditionType = new DietConditionType('snack_1');
    snack_2: DietConditionType = new DietConditionType('snack_2');
    sleep: DietConditionType = new DietConditionType('sleep');
    water: DietConditionType = new DietConditionType('water');

    isFalsyValue(value: string | number) {
        return !Boolean(value);
    }

    setNA(
        ele:
            | 'breakfast'
            | 'lunch'
            | 'snack_1'
            | 'snack_2'
            | 'sleep'
            | 'water'
            | 'dinner'
    ) {
        if (this.isFalsyValue(this[ele].properties[0].time)) {
            this[ele].properties[0].time = 'N/A';
        }
        if (this.isFalsyValue(this[ele].properties[0].quantity)) {
            this[ele].properties[0].quantity_string = 'N/A';
        }
        if (this.isFalsyValue(this[ele].properties[0].quantity_description)) {
            this[ele].properties[0].quantity_description = 'N/A';
        }
    }

    dietFoodConditon(
        food_type:
            | 'breakfast'
            | 'lunch'
            | 'snack_1'
            | 'snack_2'
            | 'sleep'
            | 'water'
            | 'dinner'
    ): boolean {
        return (
            (this[food_type].properties[0].quantity_description?.length > 0 &&
                this[food_type].properties[0].timeDate != null) ||
            this[food_type].properties[0].quantity > 0
        );
    }

    setData(patient_dietary_data: DietConditionType[]) {
        let data_type_names = [
            'breakfast',
            'lunch',
            'snack_1',
            'snack_2',
            'sleep',
            'water',
            'dinner'
        ];
        data_type_names.forEach(
            (
                ele:
                    | 'breakfast'
                    | 'lunch'
                    | 'snack_1'
                    | 'snack_2'
                    | 'sleep'
                    | 'water'
                    | 'dinner'
            ) => {
                let number = patient_dietary_data.findIndex(
                    (ele1) => ele1.data_type == ele
                );
                if (number > -1) {
                    this[ele] = patient_dietary_data[number];
                    if (!this.isFalsyValue(this[ele].properties[0].quantity)) {
                        this[ele].properties[0].quantity_string =
                            this[ele].properties[0].quantity.toString();
                    }
                }
                this.setNA(ele);
            }
        );
    }
}

// export class dietFoodDataTextareaList {
//     name: "Breakfast" | "Lunch" | "Snack 1" | "Snack 2" | "Dinner" = "Breakfast";
//     field_name: "breakfast" | "lunch" | "snack_1" | "snack_2" | "dinner" = "breakfast";
// }

export class consultApiData {
    patient_guid: string = null;
    consultation_type_id: number = null;
    is_followup: boolean = false;
    followup_consultation_id: number = 1;
    specialty_id: number[] = [];
    additional_offers: number[] = [];
    priority_type_id: number = null;
    condition_description: string = '';
    consultation_communication_type_id: number = 1;
    accepted_terms_id: number = 1;
    slot_doctor_choose: boolean = true;
    choose_dietition: boolean = false;
    slot1_primary_from: Date = null;
    slot1_primary_to: Date = null;
    user_package_id: string = null;
    discount_id: string = null;
    patient_dietary_data: DietConditionType[] = [];
    preferred_user_guid: string = null;
    diet_preferrence_id: number = null;
    other_diet_preferrence: string = null;
    health_goal: string = '';
    preferred_slot_id: number = null;
}

export class NewConsultationWorkflow {
    consultation_data: Consultation;
    patientreg: Patient_Registration_Data;
    phones_exists_response: ApiResult;
    phone_exists_api_data: PhoneNumberExists;
    showInput: boolean;
    currentScreenIndex: number;
    tabs: CONSULTATION_FORMS_TABS;
    edit_phone_no: boolean;
    countries_code_3: { [key: string]: CountrySelectedValue } = {};
    countries_code_2: { [key: string]: CountrySelectedValue } = {};

    constructor(terms: string, max_date: Date) {
        this.consultation_data = new Consultation(3);
        this.patientreg = new Patient_Registration_Data(terms, max_date);
        this.phones_exists_response = new ApiResult(false);
        this.phone_exists_api_data = new PhoneNumberExists();
        this.currentScreenIndex = CONSULTATION_FORMS_TABS.BASIC_FORM;
        this.edit_phone_no = false;
        this.showInput = false;
    }
}

export class Consultation {
    consultApiData: consultApiData = new consultApiData();
    other_data: Other_Consultation_Data = new Other_Consultation_Data(0);
    regExp: REG_EXP = new REG_EXP();
    patient_state: any = {};
    const_data = {
        CONSULTATION_TYPES: CONSULTATION_TYPES,
        CONDITION_DESCRIPTION: MEDICAL_CONDITION_DESCRIPTION,
        DIET_HEALTH_GOAL: DIET_HEALTH_GOAL,
        DIET_FOOD_DESC: DIET_FOOD_DESC,
        DIET_FOOD_DESC_PLACEHOLDER: DIET_FOOD_DESC_PLACEHOLDER
    };

    constructor(current_list_count: number) {
        this.other_data = new Other_Consultation_Data(current_list_count);
    }

    clear_slots() {
        this.consultApiData.slot1_primary_from = null;
        this.consultApiData.slot1_primary_to = null;
    }

    clear_preferred_dietition() {
        this.consultApiData.preferred_user_guid = null;
    }

    reset_pay_data() {
        this.other_data.is_pay = true;
    }

    reset_package_status_data() {
        this.other_data.packages_status_data = [];
    }

    reset_user_package_id() {
        this.consultApiData.user_package_id = null;
    }

    resetSpecialties() {
        this.other_data.selectedSpecialtyId = null;
        this.consultApiData.specialty_id = [];
    }

    // resetConsultationType() {
    //     this.consultApiData.consultation_type_id = null;
    // }

    resetFollowUpConultationID() {
        this.consultApiData.followup_consultation_id = 1;
        this.other_data.selectedClosedConsultation = null;
    }

    resetPriorityID() {
        this.consultApiData.priority_type_id = null;
    }

    resetPriorityList() {
        this.other_data.priority_list = [];
    }

    resetSelectedDietPlan() {
        this.other_data.selectedDietPlan = null;
    }

    resetConsultationData() {
        this.other_data.packageConsultDoctor.otherData.consultationDisabled = false;
    }

    resetSpecialtyData() {
        this.other_data.packageConsultDoctor.otherData.specialtyHide = false;
        this.other_data.packageConsultDoctor.otherData.specialty_name = '';
    }

    resetPriorityData() {
        this.other_data.packageConsultDoctor.otherData.priorityDisabled = false;
        this.other_data.packageConsultDoctor.otherData.priority_type_id = null;
    }

    resetSlotFetch() {
        this.other_data.slotsFetch = new SlotsFetch();
    }

    resetDoctorChoose() {
        this.consultApiData.slot_doctor_choose = true;
    }

    resetPreferredSlot() {
        this.consultApiData.preferred_slot_id = null;
    }

    // only if preferred lost is not selected and doctor chose slot is false
    isPreferredSlotSelected(): boolean {
        return this.other_data.slotsFetch.other_data.is_display && this.consultApiData.preferred_slot_id != null;
    }

    isPreferredSlotNotSelected(): boolean {
        return this.other_data.slotsFetch.other_data.is_display && this.consultApiData.preferred_slot_id == null;
    }

    setSlotDoctorChoose() {
        if (this.isPreferredSlotSelected())
            this.consultApiData.slot_doctor_choose = false;
        if (this.isPreferredSlotNotSelected())
            this.consultApiData.slot_doctor_choose = true;
    }

    resetPackagesDisabled() {
        this.other_data.packageConsultDoctor.otherData.packagesDiabled = false;
    }

    resetPackageData() {
        this.resetConsultationData();
        this.resetSpecialtyData();
        this.resetSpecialties();
        this.resetPriorityData();
        this.resetPriorityID()
        this.resetSlotFetch();
        this.resetDoctorChoose();
        this.resetPackagesDisabled();
        this.resetPreferredSlot();
    }
}

export class Nutrition_Health_Consultation_Plans_List_RadioBtnValue {
    id: number = 0;
    isFree: boolean = false;
}
export class Nutrition_Health_Consultation_Plans_List extends Nutrition_Health_Consultation_Plans_List_RadioBtnValue {
    consultation_name: string = '';
    amount: string = '';
    description: string = '';
    number_of_consultations: number = 0;
    image_url: string = '';
    raw_amount: string = '';
    value: Nutrition_Health_Consultation_Plans_List_RadioBtnValue =
        new Nutrition_Health_Consultation_Plans_List_RadioBtnValue();
}

export class Nutrition_Health_Consultation_Plans {
    plans_list: Nutrition_Health_Consultation_Plans_List[] = [];
    api_result: ApiResult = new ApiResult(false);
}

export class Nutrition_Health_Consultation {
    plans: Nutrition_Health_Consultation_Plans =
        new Nutrition_Health_Consultation_Plans();
}

export class SlotsFetchApiData {
    vendor_guid: string = null;
    slot_date: string = null;
    primary_speciality_id: number = null;
}

export class SlotsFetchOtherData {
    is_display: boolean = false;
}

export class TimeSlotsData {
    selectedDate: Date = null;
    timeSlots: SelectItem[] = [];
    timeSlots_api_data: SlotData[] = [];
    selectedSlot: number = null;
    minDate: Date = new Date(new Date().setDate((new Date()).getDate() + 1));
    maxDate: Date = new Date(new Date().setDate((new Date()).getDate() + 30));;
    show_empty_messsage: boolean = false;
}

export class SlotsFetch {
    api_data: SlotsFetchApiData = new SlotsFetchApiData();
    api_result: ApiResult = new ApiResult(false);
    other_data: SlotsFetchOtherData = new SlotsFetchOtherData();
    timeSlots: TimeSlotsData = new TimeSlotsData();
}

export class SupportConsultDoctorVerifyApi {
    req_id: number = null;
    patient_guid: string = null;
}

export class SupportConsultDoctorOtherData {
    patient_name: string = "";
    vendor_name: string = "";
    is_verified: boolean = true;
}
export class SupportConsultDoctorData {
    verifyApi: SupportConsultDoctorVerifyApi = new SupportConsultDoctorVerifyApi();
    otherData: SupportConsultDoctorOtherData = new SupportConsultDoctorOtherData();
    verifyApiResult: ApiResult = new ApiResult();
}

export class Other_Consultation_Data {
    is_pay: boolean = true;
    discount_applied: boolean = false;
    discount_message: string = "";
    packages_status_data: PackageStatusModel[] = [];
    members_data: SelectItem[] = [];
    preferredDieticianData: SelectItem[] = [];
    dietPreferenceData: SelectItem[] = [];
    specialty_data: SelectItem[] = [];
    close_consultation_data: SelectItem[] = [];
    priority_list: ConsultationPriority[] = [];
    offers: offers[] = [];
    offers_check: boolean[] = [];
    todayDate: Date = new Date();
    minDays: Date = new Date();
    maxDays: Date = new Date();
    // is_follow_up: boolean = false;
    has_follow_up: boolean = false;
    selectedClosedConsultation: any = null;
    selectedSpecialtyId: number = null;
    // packages_list: PackageModel[] = [];
    // selected_packages: PackageFormBody = new PackageFormBody();
    selected_additional_offer: number = null;
    selectedDietPlan: Nutrition_Health_Consultation_Plans_List_RadioBtnValue =
        null;
    discountCodeList: CouponCode[] = [];
    coupon_code_data: CouponCodeData = new CouponCodeData(0);
    // selected_discount_code: string = null;
    payment_data: Payment_Data = new Payment_Data();
    print_data: InvoicePrint = new InvoicePrint();
    nutritionHealthCons: Nutrition_Health_Consultation =
        new Nutrition_Health_Consultation();
    tabview_Data: TabView_Data = new TabView_Data(0, 5);
    component_leave: Component_Leave = new Component_Leave();
    form_api_result: ApiResult = new ApiResult(false);
    user_packages_list_api_result: ApiResult = new ApiResult(false);
    // packages_list_api_result: ApiResult = new ApiResult(false);
    // packages_form_api_result: ApiResult = new ApiResult(false);
    members_list_api_result: ApiResult = new ApiResult(false);
    specialty_list_api_result: ApiResult = new ApiResult(false);
    priority_list_api_result: ApiResult = new ApiResult(false);
    discount_list_api_result: ApiResult = new ApiResult(false);
    discount_code_apply_api_result: ApiResult = new ApiResult(false);
    submit_consultation_api_result: ApiResult = new ApiResult(false);
    closed_consultation_list_api_result: ApiResult = new ApiResult(false);
    diet_preference_list_api_result: ApiResult = new ApiResult(false);
    dietition_list_api_result: ApiResult = new ApiResult(false);
    dietFoodData: DietFoodData = new DietFoodData();
    // patient_profile_complete: { [key: string]: boolean} = {};
    patient_country_map: { [key: string]: number } = {};
    packageConsultDoctor: PackageConsultDoctor = new PackageConsultDoctor();
    slotsFetch: SlotsFetch = new SlotsFetch();
    p_editdata: patientEdit_Data = new patientEdit_Data();
    supportConsult: SupportConsultDoctorData = new SupportConsultDoctorData();
    is_package_diet: boolean = false;
    constructor(current_list_count: number) {
        this.coupon_code_data = new CouponCodeData(current_list_count);
    }
}

export class priority {
    id: number;
    transaction_type: string;
    consultation_name: string;
    priority_type: string;
    specialty_id: number;
    amount: number | string;
    response_min: number;
    response_max: number;
    description: string;
    image_url?: string;
    number_of_consultations?: number;
    raw_amount?: number;
    country: {
        currency_type: string;
    };
    p_priority_doctor_origin: {
        country: {
            country_name: string;
            currency_type: string;
        };
    };
}

export class ConsultationPriority {
    id: number;
    amount: string;
    country: {
        currency_type: string;
    };
    p_priority_doctor_origin: {
        country: {
            country_name: string;
            currency_type: string;
        };
    };
    price_label: string;
    no_price_label: string;
}

export class offers extends priority { }

export class DietConsultationData {
    api_result: ApiResult = new ApiResult();
    is_diet_consultation: boolean = false;
    is_paid: boolean = false;
    dietFoodData: DietFoodData = new DietFoodData();
    patient_dietary_data: DietConditionType[] = [];
    health_goal: string = '';
    final_diet_preferrence: string = '';
}

export class ConsultationData {
    patient_guid: string = '';
    doctor_guid: string = '';
    consultation_id: number = 0;
    consultation_type_id: number = 0;
    consultations_left: number = 0;
}

export enum consultation_status {
    open = 'OPEN',
    scheduled = 'SCHEDULED',
    inprogress = 'IN PROGRESS',
    closed = 'CLOSED',
    cancelled = 'CANCELLED'
}
